
<div>
  <field-item
    @click="select(section.select(objectDynamicInput, endPoint, apiMessageType, path))"
    :disabled="handler.isDisabled(objectDynamicInput, parentTreeContext)"
  >
    <row>
      <prefix>
        <icon glyph="box"/>
      </prefix>
      <column>
        {{objectDynamicInput.name}}
      </column>
    </row>
  </field-item>

  <collapsible-section
    class="collapse-item"
    :id="`dynamicInputsCollapse-${handler.variable.id}-${objectDynamicInput.id}-properties`"
    control-name="apiEndPointPropertiesCollapse"
    :is-open="false"
  >
    <template #section-header>
      Properties
    </template>

    <template #section-contents>
      <field-item
        v-for="prop in section.properties"
        :key="prop.clientIdOrId"
        :disabled="handler.isDisabled(prop, computedChildTreeContext)"
        @click="select(section.select(prop, endPoint, apiMessageType, completePathFor(prop)))"
      >
        <row>
          <prefix>
            <icon :glyph="dynamicInputGlyph(prop)"/>
          </prefix>
          <column>
            {{prop.name}}
          </column>
        </row>
      </field-item>

      <collapsible-section
        v-for="prop in section.objects"
        class="collapse-item"
        :id="`dynamicInputsCollapse-${handler.variable.id}-${prop.id}`"
        control-name="apiEndPointObjectCollapse"
        :is-open="false"
        :key="prop.clientIdOrId"
      >
        <template #section-header>
          {{ prop.name }}
        </template>

        <template #section-contents>
          <api-object-data
            :handler="handler"
            :end-point="endPoint"
            :apiMessageType="apiMessageType"
            :object-dynamic-input="prop"
            :path="completePathFor(prop)"
            :q="lowerQ"
            @select="select"
            :parent-tree-context="computedChildTreeContext"
          />
        </template>
      </collapsible-section>
    </template>
  </collapsible-section>
</div>
